// Хелперы для OIDC Authorization Code + PKCE (RFC 7636).
//
// Все значения — base64url без padding. SHA-256 берётся из WebCrypto, поэтому
// функции async. crypto.subtle доступен в любом современном браузере; в
// SSR-окружении / Node без WebCrypto эти функции вызывать нельзя — но это
// чистый SPA, так что норм.

function base64UrlEncode(buf: ArrayBuffer | Uint8Array): string {
  const bytes = buf instanceof Uint8Array ? buf : new Uint8Array(buf);
  let bin = "";
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]!);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function randomString(byteLen = 48): string {
  const buf = new Uint8Array(byteLen);
  crypto.getRandomValues(buf);
  return base64UrlEncode(buf);
}

export async function codeChallengeS256(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(verifier),
  );
  return base64UrlEncode(digest);
}

const STATE_KEY = "lplanner.pkce.state";
const NONCE_KEY = "lplanner.pkce.nonce";
const VERIFIER_KEY = "lplanner.pkce.verifier";
const RETURN_TO_KEY = "lplanner.pkce.returnTo";

export interface PkceParams {
  state: string;
  nonce: string;
  codeVerifier: string;
  codeChallenge: string;
}

export async function generatePkceParams(): Promise<PkceParams> {
  const state = randomString(32);
  const nonce = randomString(32);
  const codeVerifier = randomString(48);
  const codeChallenge = await codeChallengeS256(codeVerifier);
  return { state, nonce, codeVerifier, codeChallenge };
}

export function savePkce(params: PkceParams, returnTo?: string): void {
  sessionStorage.setItem(STATE_KEY, params.state);
  sessionStorage.setItem(NONCE_KEY, params.nonce);
  sessionStorage.setItem(VERIFIER_KEY, params.codeVerifier);
  if (returnTo) sessionStorage.setItem(RETURN_TO_KEY, returnTo);
}

export function consumePkce(): {
  state: string | null;
  nonce: string | null;
  codeVerifier: string | null;
  returnTo: string | null;
} {
  const state = sessionStorage.getItem(STATE_KEY);
  const nonce = sessionStorage.getItem(NONCE_KEY);
  const codeVerifier = sessionStorage.getItem(VERIFIER_KEY);
  const returnTo = sessionStorage.getItem(RETURN_TO_KEY);
  sessionStorage.removeItem(STATE_KEY);
  sessionStorage.removeItem(NONCE_KEY);
  sessionStorage.removeItem(VERIFIER_KEY);
  sessionStorage.removeItem(RETURN_TO_KEY);
  return { state, nonce, codeVerifier, returnTo };
}
